<template>
  <div class="passcode-picker">
    <div class="passcode-inputs">
      <div
        class="input-field"
        @click="focusInput(index)"
        :class="classForInput(index)"
        v-for="(v, index) in passcode"
        :key="index"
      >
        <input
          :ref="passcodeInputRef"
          :data-index="index"
          v-model="passcode[index]"
          type="password"
          pattern="[0-9]*"
          inputmode="numeric"
          maxlength="1"
          autocomplete="no-pass"
          @keydown="handleKeyDown"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    passcodeLength: {
      type: Number,
      default: 4
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      passcodeInputRef: 'passcode-input',
      passcode: []
    }
  },
  created () {
    this.passcode = new Array(this.passcodeLength).fill('')
  },
  mounted () {
    this.focusInput(0)
  },
  methods: {
    focusInput (index) {
      this.$refs[this.passcodeInputRef][index].focus()
    },
    isBackspace (code) {
      return code === 8
    },
    isNumber (code) {
      return (code >= 48 && code <= 57) || (code >= 96 && code <= 105)
    },
    isArrows (code) {
      return code === 37 || code === 39
    },
    validInput (code) {
      return this.isNumber(code) || this.isBackspace(code) || this.isArrows(code)
    },
    handleKeyDown (event) {
      const { keyCode, target } = event
      const index = parseInt(target.dataset.index)

      if (!this.validInput(keyCode)) {
        event.preventDefault()
        event.stopPropagation()
        return
      }

      if (this.isBackspace(keyCode)) {
        setTimeout(() => {
          if (index > 0 && this.passcode[index].length < 1) {
            const previousIndex = index - 1
            this.focusInput(previousIndex)
            this.passcode[previousIndex] = ''
          } else {
            this.passcode[index] = ''
          }
          this.$forceUpdate()
        }, 50)
        return
      }

      setTimeout(() => {
        if (this.passcode[index].length > 0) {
          if (index < (this.passcodeLength - 1)) {
            const nextIndex = index + 1
            this.focusInput(nextIndex)
            this.$forceUpdate()
          } else {
            this.$emit('complete', this.passcode.join(''))
          }
        }
      }, 50)
    },
    classForInput (index) {
      return this.passcode[index] ? 'filled' : ''
    }
  }
}
</script>

<style scoped>
.passcode-picker {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}
.passcode-inputs {
  display: flex;
  justify-content: space-between;
  width: 300px;
}
.input-field {
  width: 64px;
  height: 64px;
  position: relative;
}
.input-field.filled::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 42px;
  height: 42px;
  background-color: var(--text-heading);
  border: 10px solid var(--not-valid-gray);
  border-radius: 25px;
}
input {
  -webkit-appearance: none;
  width: 64px;
  height: 64px;
  text-align: center;
  font-size: 24px;
  letter-spacing: 10px;
  background-color: var(--not-valid-gray);
  border-radius: 32px;
  border: 4px solid var(--not-valid-gray);
  font-weight: bold;
}
input:focus {
  border-color: var(--text-heading);
}
</style>
